export default "__VITE_ASSET__DRcuYV$4__"